import styled from "@emotion/styled";
import React from "react";

const Hr = styled.hr`
  height: 1px;
  color: ${(props) => props.theme.colors.border2};
  background-color: ${(props) => props.theme.colors.border2};
  margin: 2rem 0;
  font-size: 0;
  border: 0;
`;

export const hrMapper = (
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLHRElement>,
    HTMLHRElement
  >
) => {
  return <Hr {...props} />;
};
